import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { fromIni } from '@aws-sdk/credential-providers';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { config } from 'src/config/config';

const s3Client = new S3Client({ region: 'ap-northeast-1' });
if (!!config().externals.awsProfile) {
  s3Client.config.credentials = fromIni({ profile: config().externals.awsProfile });
}
const BUCKET_NAME = config().externals.couponBucketName;

class S3Util {

  public getClientPsUrl = async (args: {
    companyId: number,
    brandId: number,
    subKey: string,
  }): Promise<string> => {

    const {
      companyId,
      brandId,
      subKey,
    } = args;

    const key = `clients/${companyId}/${brandId}/${subKey}`;

    try {
      const command = new GetObjectCommand({
        Bucket: BUCKET_NAME,
        Key: key,
      });
      const presignedUrl = await getSignedUrl(s3Client, command, { expiresIn: 60 * 60, });
      return presignedUrl;
      
    } catch (error: any) {
      throw new Error(error?.message)
    }

  }
}

export const s3Util = new S3Util();
